import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavigationService } from '../services/navigation.service';
import { firstValueFrom } from 'rxjs';

export const redirectToSectionSelectionIfNeeded: CanActivateFn = async (route, state) => {
	const nav = inject(NavigationService);

	const matrixParams: Record<string, string> = await firstValueFrom(nav.matrixParams$);

	const sectionUuid: string = matrixParams['sectionUuid'];

	if (!sectionUuid) {
		console.warn(
			'no sections found...send to section selection.',
			matrixParams,
			'state.url',
			state.url
		);

		nav.navigate(['/', 'my', 'sections']);

		return false;
	}

	return true;
};
